import Link from 'next/link';

interface HeroSectionProps {
  className?: string;
}

const HeroSection = ({ className = '' }: HeroSectionProps) => {
  return (
    <section className={`relative bg-background py-20 lg:py-28 ${className}`}>
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="max-w-4xl">
          <div className="mb-16 h-px w-20 bg-accent"></div>
          <div className="mb-7 font-heading text-xl italic text-primary">
            Silk Solutions — Real Estate Problem Solvers
          </div>

          <h1 className="max-w-[900px] text-[52px] font-normal leading-[0.95] text-foreground md:text-[74px] lg:text-[88px]">
            Your situation is unique. Your solution should be{' '}
            <span className="italic text-plum">too.</span>
          </h1>

          <p className="mt-8 max-w-[720px] font-heading text-[22px] leading-[1.55] text-muted-foreground">
            Most real estate processes are built for one type of seller. We built ours for everyone
            else.
          </p>

          <div className="mt-10 flex flex-col gap-4 sm:flex-row">
            <Link
              href="/for-sellers#property-form"
              className="inline-flex items-center justify-center bg-plum px-6 py-4 text-[12px] font-bold uppercase tracking-[0.24em] text-primary-foreground transition-colors hover:bg-plum-deep"
            >
              Tell Us About Your Property →
            </Link>
          </div>
        </div>

        <div className="mt-20 border-y border-border py-12">
          <p className="max-w-5xl font-heading text-[38px] font-normal leading-[1.08] text-foreground md:text-[56px]">
            There&apos;s more than one way to sell a home.{' '}
            <span className="italic text-plum">We know all of them.</span>
          </p>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
